import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

class Checkbox extends Component {
  static propTypes = {
    htmlId: PropTypes.string,
    name: PropTypes.string,
    label: PropTypes.any,
    required: PropTypes.bool,
  };

  static defaultProps = {
    htmlId: 'id',
    name: 'name',
    label: '',
    required: false,
  };

  render() {
    const { htmlId, name, label, required } = this.props;

    return (
      <Root {...this.props}>
        <input type="checkbox" id={htmlId} name={name} required={required} />
        <Label htmlFor={htmlId}>{label}</Label>
      </Root>
    );
  }
}

const Root = styled.div`
  width: 100%;
  position: relative;
  input[type='checkbox'] {
    border: 1px solid #ffffff;
    width: 36px;
    height: 36px;
    position: absolute;
    top: 0;
    left: 0;
    &:checked::after {
      content: '';
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      background-color: rgba(255, 255, 255, 0.75);
      width: 20px;
      height: 20px;
    }
  }
`;

const Label = styled.label`
  margin-left: 55px;
`;

export default Checkbox;



// WEBPACK FOOTER //
// ./src/pages/Register/elements/Form/elements/Checkbox.js